"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

var _CardSection = _interopRequireDefault(require("../../../structure/CardSection"));

var _InfoDialog = _interopRequireDefault(require("../../../overlay/InfoDialog"));

var _FormatPrice = require("../../../../utils/FormatPrice");

var _pclnModal = require("pcln-modal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function SummaryOfChargesHotelExpenses(_ref) {
  var className = _ref.className,
      rooms = _ref.rooms,
      nights = _ref.nights,
      subTotal = _ref.subTotal,
      taxes = _ref.taxes,
      resortFees = _ref.resortFees,
      hotelFees = _ref.hotelFees,
      insuranceFees = _ref.insuranceFees,
      currencySymbol = _ref.currencySymbol,
      currencyCode = _ref.currencyCode,
      taxesAndFeesModalContent = _ref.taxesAndFeesModalContent,
      hotelFeesModalContent = _ref.hotelFeesModalContent;
  var roomText = rooms > 1 ? 'Rooms' : 'Room';
  var nightText = nights > 1 ? 'Nights' : 'Night';
  var stayText = "".concat(rooms, " ").concat(roomText, " x ").concat(nights, " ").concat(nightText);

  var getCurrencyText = function getCurrencyText(value) {
    return value ? "".concat(currencySymbol).concat((0, _FormatPrice.formatPrice)(value.toFixed(2)), " ").concat(currencyCode === 'USD' ? '' : currencyCode) : null;
  };

  var subTotalText = getCurrencyText(subTotal);
  var taxesText = getCurrencyText(taxes);
  var resortFeesText = getCurrencyText(resortFees);
  var hotelFeesText = getCurrencyText(hotelFees);
  var insuranceFeesText = getCurrencyText(insuranceFees);
  var scrollLockHelper = new _pclnModal.ScrollLock();
  return _react["default"].createElement(_CardSection["default"], {
    className: className
  }, subTotal > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    justifyContent: "space-between"
  }, _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, stayText), _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, subTotalText)), _react["default"].createElement(_pclnDesignSystem.Flex, {
    justifyContent: "space-between",
    mt: 2
  }, _react["default"].createElement(_InfoDialog["default"], {
    scrollLockHelper: scrollLockHelper,
    title: "Taxes and Fees",
    buttonText: "Taxes and Fees"
  }, taxesAndFeesModalContent), _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, taxes > 0 ? taxesText : 'May Apply')), resortFees > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    justifyContent: "space-between",
    mt: 2
  }, _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, "Resort Fees"), _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, resortFeesText)), hotelFees > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    justifyContent: "space-between",
    mt: 2
  }, _react["default"].createElement(_InfoDialog["default"], {
    scrollLockHelper: scrollLockHelper,
    title: "Hotel Fees",
    buttonText: "Hotel Fees"
  }, hotelFeesModalContent), _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, hotelFeesText)), insuranceFees > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    justifyContent: "space-between",
    mt: 2
  }, _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, "Travel Insurance"), _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1
  }, insuranceFeesText)));
}

SummaryOfChargesHotelExpenses.displayName = 'SummaryOfChargesHotelExpenses';
SummaryOfChargesHotelExpenses.propTypes = {
  className: _propTypes["default"].string,
  rooms: _propTypes["default"].number.isRequired,
  nights: _propTypes["default"].number.isRequired,
  subTotal: _propTypes["default"].number.isRequired,
  taxes: _propTypes["default"].number,
  resortFees: _propTypes["default"].number,
  hotelFees: _propTypes["default"].number,
  insuranceFees: _propTypes["default"].number,
  currencySymbol: _propTypes["default"].string,
  currencyCode: _propTypes["default"].string,
  taxesAndFeesModalContent: _propTypes["default"].node,
  hotelFeesModalContent: _propTypes["default"].node
};
SummaryOfChargesHotelExpenses.defaultProps = {
  className: '',
  currencySymbol: '$',
  currencyCode: 'USD'
};

var _default = (0, _react.memo)(SummaryOfChargesHotelExpenses);

exports["default"] = _default;